import React, { useEffect, useRef, useState } from "react";
import { useNavigate, } from "react-router-dom";
import "./homeSlider.css"; // rename if needed

const AstrologerSlider = () => {
  const [astrologers, setAstrologers] = useState([]);
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/fetchastrologer")
      .then((res) => res.json())
      .then((res) => {
        if (res.status && Array.isArray(res.data)) {
          const basePath = "https://dashboard.jyotirvani.com/" + res.path;
          const formatted = res.data.map((item) => ({
            id: item.id,
            name: item.name,
            experience: item.experience + " Years",
            languages: item.speak?.split(",").map((x) => x.trim()),
            expertise: item.Expertise?.split(",").map((x) => x.trim()),
            profileImage: basePath + item.profileimage,
            status: item.status === 1 ? "Online" : "Offline",
          }));
          setAstrologers(formatted);
        }
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
  const slider = sliderRef.current;
  let scrollAmount = 0;

  const slideInterval = setInterval(() => {
    if (slider) {
      scrollAmount += 320; // Adjust to match .astro-card width + gap
      if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
        scrollAmount = 0; // Reset to start
      }
      slider.scrollTo({ left: scrollAmount, behavior: "smooth" });
    }
  }, 5000); // Auto-slide every 5 seconds

  return () => clearInterval(slideInterval); // Cleanup on unmount
}, []);


  return (
    <div className="astro-slider-section">
      <div className="container">
        <h2 className="home-blog-title">
          MEET OUR <span>ASTROLOGERS</span>
        </h2>
       

        <div className="astro-slider-container" ref={sliderRef}>
          {astrologers.map((astro, index) => (
            <div key={index} className="astro-card">
              <img
                src={astro.profileImage}
                alt={astro.name}
                className="astro-image"
              />
              <div className="astro-details">
                <h3>{astro.name}</h3>
                <h4 className="astro-category">{astro.experience}</h4>
                {/* <p>Status:{" "}
                  <span
                    style={{
                      color: astro.status === "Online" ? "green" : "red",
                      fontWeight: "bold"
                    }}
                  >
                    {astro.status}
                  </span>
                </p> */}

                <div className="astro-buttons">
                  <button
                    className="astro-buttons"
                    onClick={() => navigate(`/profile/${astro.id}`)}
                  >
                    View Profile
                  </button>
                  <button
  className="astro-buttons"
  onClick={() => navigate(`/profile/${astro.id}`)}
>
  Book Now
</button>
                  {/* <button
                    className="astro-buttons"
                  >
                    <a
                      href={`https://wa.me/919616339090?text=${encodeURIComponent(
                        `Hello, I want to book a consultation with ${astro.name}. Here are my birth details:\n\nFull Name:\nDate of Birth:\nTime of Birth:\nPlace of Birth:\nContact Number:\n\nPlease confirm the booking.`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                     
                    >
                      Book Now
                    </a>
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AstrologerSlider;
